export const url = 'https://mgapi.bitfeifan.com/'
// export const url = 'http://usadmin.geyijituan.com/'

// export const url = 'http://111.30.115.24:89/'
// export const url = 'http://usadmin.geyijituan.com/'
// export const url = 'http://mgapi.bitfeifan.com/'

